import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon } from "@mantine/core";
import AnnouncementDeleteApiService from "../services/api/AnnouncementDeleteApiService";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import ConfirmDeleteModel from "../../../themes/elements/ConfirmDeleteModel";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type DeleteAnnouncementActionIconProps = {
  id: number;
};

const DeleteAnnouncementActionIcon: React.FC<
  DeleteAnnouncementActionIconProps
> = ({ id }) => {
  const [opened, setOpened] = useState(false);
  const { showToast } = useToasts();
  const { isLoading, isSuccess, isError, error, mutate, data } =
    AnnouncementDeleteApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "announcement_delete_failed",
        data: {
          message: HttpClientError(error),
        },
      });

      setOpened(false);
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "announcement_delete_success" });

      setOpened(false);

      // eslint-disable-next-line no-console
      queryClient
        .invalidateQueries("AnnouncementListApiService")
        // eslint-disable-next-line no-console
        .then((res) => console.log(res));
    }
  }, [isSuccess, data]);

  return (
    <>
      <ConfirmDeleteModel
        isLoading={isLoading}
        label="announcement"
        onClose={() => setOpened(false)}
        onConfirm={() => mutate(id)}
        opened={opened}
      />

      <ActionIcon onClick={() => setOpened(true)}>
        <Trash2 size={18} />
      </ActionIcon>
    </>
  );
};

export default DeleteAnnouncementActionIcon;
